import { getClassificationTypeImage } from './attributesUtil'
import { CLASSICATION_TYPE } from '../constants'
import React from 'react'

const iconBaseUrl = '../../assets/images/classificationTypes/'
export const getClassificationIcon = (type?: CLASSICATION_TYPE) => {
  return <img src={iconBaseUrl + getClassificationTypeImage(type)} />
}
